import { checkPermission } from "./checkPermission";
import { usePermissions } from "./usePermissions";

/**
 * Checks whether the currently signed in user has all the specified permissions.
 * @param permissions The set of permissions to check for.
 * @returns `true` if the user has all the permissions, otherwise `false`.
 */
export function usePermissionCheck(permissions: string | ReadonlyArray<string | ReadonlyArray<string>>): boolean {
  const [shellPermissions] = usePermissions();
  return checkPermission(shellPermissions, permissions);
}
